import { twMerge } from 'tailwind-merge';

import { TransactionsDetailsModal } from '@/features/transactions-modal';
import { FINAL_STATUSES } from '@/features/transactions-modal/config';

import {
  ITransaction,
  TransactionAmount,
  TransactionLabel,
  getTransactionAvatar,
} from '@/entities/transaction';

import { AvatarWithIndicator } from '@/shared/ui';

interface TransactionItemProps {
  transaction: ITransaction;
  classNames?: { label?: string; wrapper?: string };
}
export const TransactionItem = ({
  transaction,
  classNames,
}: TransactionItemProps) => {
  const { avatar, defaultAvatar } = getTransactionAvatar(transaction);
  return (
    <TransactionsDetailsModal transaction={transaction} key={transaction.id}>
      {(onDetailClick) => (
        <div
          className={twMerge(
            'grid cursor-pointer grid-cols-[max-content_1fr_max-content] py-2',
            classNames?.wrapper,
          )}
          onClick={onDetailClick}
          tabIndex={0}
        >
          <AvatarWithIndicator
            className="pr-4"
            showIndicator={!FINAL_STATUSES.includes(transaction.status)}
            avatar={avatar}
            defaultAvatar={defaultAvatar}
          />
          <TransactionLabel
            transaction={transaction}
            className={classNames?.label}
          />

          <TransactionAmount transaction={transaction} />
        </div>
      )}
    </TransactionsDetailsModal>
  );
};
